import { API_URL } from './backend-url'

const endpoints = {
  pelamarGetAllEndpoint: `${API_URL}/pelamar`,
  blacklistEndpoint: `${API_URL}/user/blacklist`,
  unblacklistEndpoint: `${API_URL}/user/unblacklist`,
  statusSetEndpoint: `${API_URL}/user/status`,
  pelamarBelumMengikutiRekrutmen: `${API_URL}/pelamar/data-wajib/100`,

  pelamarValidasi: `${API_URL}/pelamar/validasi`,
  pelamarkehadiran: `${API_URL}/pelamar/kehadiran`,

}

export default endpoints
